// extracted by mini-css-extract-plugin
export var buttonContainer = "_87-1";
export var fontSizeSelect = "_87-3";
export var formatSelect = "_87-2";
export var formats = "_87-4";
export var hidden = "_87-5";
export var icon = "_87-6";
export var select = "_87-0";